<template>
    <div>
        <!-- <b-form-select v-model="localValue" @change="updateValue">
            <optgroup :label="service.label" v-for="(service, serviceIndex) in services" :key="serviceIndex">
                <option
                    v-for="(treatment, treatmentIndex) in treatments(service._id)"
                    selected="true"
                    :key="treatmentIndex"
                    :value="treatment"
                >{{ treatment.label }}</option>
            </optgroup>
        </b-form-select>-->
        <treeselect
            :value="value"
            @input="emit"
            valueFormat="object"
            openDirection="bottom"
            :placeholder="placeholder"
            :showCount="true"
            :normalizer="normalizer"
            :multiple="false"
            :disable-branch-nodes="true"
            :options="allitems"
            :noResultsText="$t('No results found')"
            :noOptionsText="$t('No options available')"
            :noChildrenText="$t('No sub-options')"
        />
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';


import { mapGetters, mapState } from 'vuex';

export default {
    props: {
        value: null,
        placeholder: { type: String, default: '' },
        params: null,
        nonPublic: Boolean,
    },
    components: {
        Treeselect
    },
    data() {
        return {
            localValue: null,
        }
    },
    computed: {
        ...mapGetters('service', { findServicesInStore: 'find' }),
        ...mapState('service', { areServicesLoading: 'isFindPending' }),
        ...mapState('treatment', { areTreatmentsLoading: 'isFindPending' }),
        ...mapGetters('treatment', { findTreatmentInStore: 'find' }),
        services() {
            const query = { public: true, $sort: { priority: 1 } }
            if (this.nonPublic)
                delete query.public
            return this.findServicesInStore({ query }).data;
        },
        allitems() {
            let services = [];
            const query = { public: true, $sort: { priority: 1 } }
            if (this.nonPublic)
                delete query.public
            this.findServicesInStore({ query }).data.forEach(service => {
                const treatmentQuery = {
                    $sort: { priority: 1 },
                    public: true,
                    serviceId: service._id,
                    ...(this.params ? this.params.query : {})
                }
                if (this.nonPublic)
                    delete treatmentQuery.public
                if (this.nonPublic)
                    delete query.public

                let treatments = this.findTreatmentInStore({ query: treatmentQuery }).data
                if (treatments.length)
                    services.push({ ...service, children: treatments })
            });
            return services;
        }

    },
    methods: {
        emit(value) {
            console.log('emit')
            this.localValue = value;
            this.$emit('input', value);
            this.$emit('change', value);
        },
        normalizer(item) {
            item.id = item._id;
            return item;
        },
        isCurrent(value) {
            return value == this.localValue;
        },
        updateValue() {
            this.$emit('input', this.localValue);
            this.$emit('change', this.localValue);
        },
        treatments(serviceId) {
            return this.findTreatmentInStore({
                query: {
                    serviceId,
                    public: true,
                }
            }).data;
        }
    }

}
</script>

<style>
.vue-treeselect__menu-container {
    min-width: 40vw !important;
}
</style>
